import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Button as BSButton } from 'reactstrap';
import { useResponsiveValue } from '@theme-ui/match-media';
import { MotorplayContext } from '../../../context';
import { Loading, Modal, PlanCard } from '../../ProductSelectionPage/motorplay/components';
import {
  useInjectBodyScripts,
  useInjectHeadScripts,
} from '../../../utils/hooks/useInjectScripts';
import { injectTrackingScripts } from '../../ProductSelectionPage/motorplay/utils';
import { PaymentGateways } from '../../../enums';
import ItemsCarousel from 'react-items-carousel';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const ProductsPage = ({ history, user, addProduct, products, setCurrentSubPaymentMethod, cleanOrder, subPaymentMethods, userPlan, client, setIgnoreRedirect }) => {
  const {
    plans,
    setPlanToBuy,
    selectedPlan,
    loading,
    error,
    complete,
    resetError,
    openModal,
    type,
    setOpenModal,
    createSubscriptionStripe,
    completeByCoupon,
    resetErrorCoupon
  } = useContext(MotorplayContext);
  const [query, setQuery] = useState(null);
  const [activeItemIndex, setActiveItemIndex] = useState(1);
  const numberOfCards = useResponsiveValue([1,2,2]);

  useInjectHeadScripts();
  useInjectBodyScripts(true);

  const closeModal = () => {
    if (error) {
      resetError();
    }

    if (complete || completeByCoupon) {
      injectScripts();
      const cloudpayConfig = window.AppENV.cloudpay;
      window.location.href = `${
        cloudpayConfig.baseURL
      }/redirect/goBackToReturnUrl${
        window.location.search
      }&jwt=${localStorage.getItem('jwt')}`;
      return;
    }

    setOpenModal(false);
  };

  const goPayment = (e) => {
    e.preventDefault();
    resetErrorCoupon();
    cleanOrder();

    const selectedProductData = products.find((product) => product._id === selectedPlan);
    addProduct({ ...selectedProductData });
    const currentSubPaymentMethod = subPaymentMethods.find(sub => sub.countryCode.toLowerCase() === query.country.toLowerCase() && sub.active);

    setCurrentSubPaymentMethod(currentSubPaymentMethod);
    
    const correctRedirectUrl = currentSubPaymentMethod.paymentMethod === PaymentGateways.mercadopago ? 
    `/${client}/subscribe/methods/${currentSubPaymentMethod.paymentMethod}/${currentSubPaymentMethod.type}${history.location.search}` : 
    `/${client}/subscribe/my-payment-methods${history.location.search}`
    history.push(correctRedirectUrl);
  };

  const injectScripts = useCallback(() => {
    injectTrackingScripts(selectedPlan, plans);
  }, [selectedPlan, plans]);
  
  useEffect(() => {
    setIgnoreRedirect(true);
    cleanOrder();
  }, []);

  useEffect(() => {
    if (!query) return;
    if (!query.payment_id || query.country.toLowerCase() === 'ar') return;

    createSubscriptionStripe(user.token, query.payment_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useEffect(() => {
    if (query) return;

    const params = new URLSearchParams(history.location.search);
    const paramsObject = Object.fromEntries(params.entries());

    setQuery(paramsObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.search]);

  return (
    <>
      {loading && <Loading />}
      {openModal && type && (
        <Modal type={type} closeModal={closeModal} message={error} />
      )}
      <Box
        sx={{ width: '100%', marginTop: '7rem' }}
        className='MembershipSelectionPage'
      >
        <Box className='myaccount-title'>
          <h2 className='text-title'>
            <FormattedMessage id='MembershipSelectionPage.short.description.plan' />
          </h2>
        </Box>
        <Box className='selectAddOnCarousel' style={{ width: (products?.length === 1 && numberOfCards !== 1) ? '30%' : '100%', margin: '0 auto' }}>
          <ItemsCarousel
            slidesToScroll={1}
            infiniteLoop={false}
            gutter={10}
            activePosition="center"
            disableSwipe={false}
            alwaysShowChevrons={false}
            numberOfCards={products?.length > 1 ? numberOfCards : 1}
            showSlither={false}
            activeItemIndex={activeItemIndex}
            requestToChangeActive={(value) => setActiveItemIndex(value)}
            rightChevron={
              <div className="chevron chevron--right">
                <div className="chevron__icon text-white">
                  <FaChevronRight size={50} />
                </div>
              </div>
            }
            leftChevron={
              <div className="chevron chevron--left">
                <div className="chevron__icon text-white">
                  <FaChevronLeft size={50} />
                </div>
              </div>
            }
          >
          {products &&
            products?.filter(product => product.active && !product.hidden).map((product) => (
              <PlanCard
                plan={product}
                key={product._id}
                selectPlan={setPlanToBuy}
                selected={selectedPlan ? selectedPlan === product._id : userPlan.productId === product.productID}
                disabled={userPlan.productId === product.productID}
              />
            ))}
          </ItemsCarousel>
        </Box>
        <Box sx={{ maxWidth: '25rem', margin: '0 auto', marginTop: '2.5rem' }}>
          <BSButton
            className='button-continue'
            disabled={!selectedPlan}
            onClick={goPayment}
          >
            Continuar
          </BSButton>
        </Box>
      </Box>
    </>
  );
};

ProductsPage.defaultProps = {};

ProductsPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  }),
  user: PropTypes.object,
  client: PropTypes.string.isRequired,
};
export default ProductsPage;
